<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.institutions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="name-group"
                                        :label="$t('message.name')"
                                        label-for="name"
                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.name.$model"
                                            :state="$v.form.name.$dirty ? !(errorshasField('name') || $v.form.name.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.name.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.name.minLength">
                                        {{ $t('message.minCharacters', { n: 3}) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="adresse-group"
                                        :label="$t('message.adresse')"
                                        label-for="name"
                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.adresse.$model"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.adresse.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.adresse.minLength">
                                        {{ $t('message.minCharacters', { n: 3}) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="description-group"
                                        :label="$t('message.description')"
                                        label-for="description"
                                >
                                    <b-form-textarea
                                            id="description"
                                            v-model="$v.form.description.$model"
                                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                            required
                                            @focus="clearErrorField('description')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="!$v.form.description.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                        {{ getErrorsField('description') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="8">
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadFile')"
                                        label-for="upload"
                                >
                                    <b-form-file
                                            id="upload"
                                            :state="$v.form.logo.$dirty ? !$v.form.logo.$error : null"
                                            :placeholder="$t('message.uploadFile')"
                                            :file-name-formatter="formatNames"
                                            @change="setImage"
                                    ></b-form-file>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4" v-if="form.logo != ''" >
                                <b-button  @click="form.logo = null  " variant="success" class="btn-sm mt-4">
                                {{$t('message.deleteLogo')}}
                                </b-button>
                            </b-col>

                            <b-col sm="12">
                                <b-container fluid class="p-4">
                                    <b-row id="image">
                                        <b-col>
                                            <b-img-lazy
                                                    class="img-preview"
                                                    thumbnail
                                                    :src="imageSrc(form.logo)"
                                                    fluid-grow
                                                    alt=""
                                            ></b-img-lazy>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "EditInstitution",

        computed: {
            ...mapGetters(["institution", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            form: function() {
                return this.institution;
            }
        },

        data() {
            return {
                institution_id: this.$route.params.institution,
                show: true
            }
        },

        methods: {
            formatNames(files) {
                return files[0].name
            },

            setImage(event) {
                this.form.logo = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    try {
                        return URL.createObjectURL(img);
                    } catch(e) {
                        return AppConfig.imgUrl + '/public/storage/' + img;
                    }
                }

                return '';
            },

            getInstitution: function() {
                let args = {
                    institution: this.institution_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getInstitution', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let formData = new FormData();

                    formData.append('institution', this.institution_id);
                    formData.append('name', this.form.name);
                    formData.append('description', this.form.description);
                    formData.append('adresse', this.form.adresse);
                    formData.append('logo', this.form.logo);


                    let successMessage = this.$i18n.t('message.institutionUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateInstitution', { args:formData, institution: this.institution_id, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.name = '';
                this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3)

                },
                description: {
                },
                adresse: {
                },
                logo:{

                }
            }
        },

        mounted() {
            // Retrieve institution
            this.getInstitution();
        }
    }
</script>

<style scoped>

</style>